import { createAsyncThunk } from "@reduxjs/toolkit";
import { contactUsUrl } from "../ApiUrls/ContactUsApiUrl";
import axios from "axios";
import { v4 as uuidV4 } from "uuid";

export const contactUsAPI = createAsyncThunk(
  "contactUsAPI",
  async (payload) => {
    try {
      const response = await axios.post(contactUsUrl, payload, {
        headers: {
          "X-Request-Id": uuidV4(),
        },
      });
      return response.data;
    } catch (error) {
      console.log("Error : ", error);
    }
  }
);